import { addressId } from 'data/mock-data';

const mock = () => ({
  data: { addressID: addressId },
});

export default mock;
